export const pins = [
    {
        slug: 'iamsdawson',
        image: 'https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/MinimalLandingPage.png',
        title: 'portfolio landing page',
        category: 'Landing Pages',
        services: ['Web Design', 'Frontend Development', 'UI Direction'],
        year: '2025',
        summary:
            'A minimalist portfolio and landing experience designed to present creative work with clarity, strong hierarchy, and a restrained visual system.',
        website: 'https://www.iamsdawson.com',
    },
    {
        slug: 'right-quick-podcast',
        image: 'https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/Right%20Quick%20Podcast.png',
        title: 'Podcast Landing Page',
        category: 'Landing Pages',
        services: ['Web Design', 'Frontend Development', 'Landing Page Design'],
        year: '2025',
        summary:
            'A clean promotional site created for Nandi Kayy that introduces their identity and work at a glance while guiding visitors toward featured media, social connection, and direct outreach.',
        website: 'https://www.rightquickpod.com',
    },
    {
        slug: 'nandikayyy',
        image: 'https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/nandikayyy.com.png',
        title: 'nandi k.',
        category: 'Landing Pages',
        services: ['Frontend Development', 'Landing Page Design'],
        year: '2025',
        summary:
            'A podcast landing page designed to introduce the show, establish tone quickly, and give visitors a clean path to listen and learn more.',
        website: 'https://www.nandikayyy.com',
    },
    {
        slug: 'findthemfirst',
        image: 'https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/findthemfirst.png',
        title: 'Threads Leads Generator',
        category: 'Custom Web/App Builds',
        services: ['Product Design', 'Web App Architecture', 'API Integration', 'Frontend Development'],
        year: '2025',
        summary:
            'A lightweight web app that turns keyword searches on Threads into a structured lead list, then helps service providers draft and approve replies from their own profile.',
        website: 'https://findthemfirst.meshaestudios.com',
    },
];
